export const LOCAL_TRANSACTION = 'local';
export const LOCAL_TRANSACTION_UNDO_MANAGER = 'local-undo-manager';
export const LOCAL_TRANSACTION_NOT_UNDOABLE = 'local-not-undoable';
export const LOCAL_TRANSACTIONS = [
  LOCAL_TRANSACTION,
  LOCAL_TRANSACTION_UNDO_MANAGER,
  LOCAL_TRANSACTION_NOT_UNDOABLE,
];
